import { reducer as templatesReducer } from '@sunwisesoftware/racking-template-core';
import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import alerts from 'common/modules/alerts';
import customColumns from 'common/modules/customColumns';
import locationForm from 'common/modules/locationForm';
import managePassword from 'common/modules/managePassword';
import releaseNotification from 'common/modules/releaseNotification';
import serchBar from 'common/modules/serchBar';

import addPanelsModal from '../addPanelsModal';
import bomExpress from '../bomExpress';
import companyGeneral from '../companyGeneral';
import companyUsers from '../companyUsers';
import contactFile from '../contactFile';
import contacts from '../contacts';
import createAccount from '../createAccount';
import createContactModal from '../createContactModal';
import createProjectModal from '../createProjectModal';
import createProposalModal from '../createProposalModal';
import duplicateProposalModal from '../duplicateProposalModal';
import forgotPassword from '../forgotPassword';
import loadAndWindModal from '../loadAndWindModal';
import login from '../login';
import multiPanelLayout from '../multiPanelLayout';
import multiTemplateReview from '../multiTemplateReview';
import panels from '../panels';
import profile from '../profile';
import profileConfiguration from '../profileConfiguration';
import project from '../project';
import projects from '../projects';
import proposals from '../proposals';
import rackingList from '../rackingList';
import rackingProposals from '../rackingProposals';
import resetPassword from '../resetPassword';
import systems from '../systems';
import templateRender from '../templateRender';

export default (history) =>
    combineReducers({
        [addPanelsModal.NAME]: addPanelsModal.reducer,
        [alerts.NAME]: alerts.reducer,
        [bomExpress.NAME]: bomExpress.reducer,
        [companyGeneral.NAME]: companyGeneral.reducer,
        [companyUsers.NAME]: companyUsers.reducer,
        [contactFile.NAME]: contactFile.reducer,
        [contacts.NAME]: contacts.reducer,
        [createAccount.NAME]: createAccount.reducer,
        [createContactModal.NAME]: createContactModal.reducer,
        [createProjectModal.NAME]: createProjectModal.reducer,
        [createProposalModal.NAME]: createProposalModal.reducer,
        [customColumns.NAME]: customColumns.reducer,
        [duplicateProposalModal.NAME]: duplicateProposalModal.reducer,
        [forgotPassword.NAME]: forgotPassword.reducer,
        [loadAndWindModal.NAME]: loadAndWindModal.reducer,
        [locationForm.NAME]: locationForm.reducer,
        [login.NAME]: login.reducer,
        [managePassword.NAME]: managePassword.reducer,
        [multiPanelLayout.NAME]: multiPanelLayout.reducer,
        [multiTemplateReview.NAME]: multiTemplateReview.reducer,
        [panels.NAME]: panels.reducer,
        [profile.NAME]: profile.reducer,
        [profileConfiguration.NAME]: profileConfiguration.reducer,
        [project.NAME]: project.reducer,
        [projects.NAME]: projects.reducer,
        [proposals.NAME]: proposals.reducer,
        [rackingList.NAME]: rackingList.reducer,
        [rackingProposals.NAME]: rackingProposals.reducer,
        [releaseNotification.NAME]: releaseNotification.reducer,
        [resetPassword.NAME]: resetPassword.reducer,
        [systems.NAME]: systems.reducer,
        [serchBar.NAME]: serchBar.reducer,
        [templateRender.NAME]: templateRender.reducer,
        router: connectRouter(history),
        sunwiseTemplateCore: templatesReducer,
    });
